import NextImage from 'next/image';
import { useTranslation } from 'next-i18next';

import { ACTIVITIES_IMAGES } from '../../../../config';

// import Bird from '../../../assets/images/activities/bird.svg';
// import BuyFlowers from '../../../assets/images/activities/buy-flowers.svg';
// import DontCatch from '../../../assets/images/activities/dont-catch.svg';
// import DontDrink from '../../../assets/images/activities/dont-drink.svg';
// import DontEat from '../../../assets/images/activities/dont-eat.svg';
// import DontTrash from '../../../assets/images/activities/dont-trash.svg';
// import DontWalk from '../../../assets/images/activities/dont-walk.svg';
// import Excursion from '../../../assets/images/activities/excursion.svg';
// import Fire from '../../../assets/images/activities/fire.svg';
// import Music from '../../../assets/images/activities/music.svg';
// import NoBicycle from '../../../assets/images/activities/no-bicycle.svg';
// import NoCutting from '../../../assets/images/activities/no-cutting.svg';
// import NoDrones from '../../../assets/images/activities/no-drones.svg';
// import NoSmoking from '../../../assets/images/activities/no-smoking.svg';
// import Photo from '../../../assets/images/activities/photo.svg';
// import Rest from '../../../assets/images/activities/rest.svg';
// import ManWalking from '../../../assets/images/activities/walking-men.svg';
// import WithoutAnimals from '../../../assets/images/activities/without-animals.svg';

import { COMMON_LOCALE_PART } from '@/locale';

const AllowedActivity = [
  {
    icon: ACTIVITIES_IMAGES.ManWalking,
    textKey: 'rules.allowed.walking',
  },
  {
    icon: ACTIVITIES_IMAGES.Rest,
    textKey: 'rules.allowed.rest',
  },
  {
    icon: ACTIVITIES_IMAGES.Bird,
    textKey: 'rules.allowed.birds',
  },
  {
    icon: ACTIVITIES_IMAGES.Photo,
    textKey: 'rules.allowed.photos',
  },
  {
    icon: ACTIVITIES_IMAGES.Excursion,
    textKey: 'rules.allowed.tour',
  },
  {
    icon: ACTIVITIES_IMAGES.BuyFlowers,
    textKey: 'rules.allowed.buyPlants',
  },
];

const BannedActivity = [
  {
    icon: ACTIVITIES_IMAGES.NoCutting,
    textKey: 'rules.banned.cutting',
  },
  {
    icon: ACTIVITIES_IMAGES.DontEat,
    textKey: 'rules.banned.eating',
  },
  {
    icon: ACTIVITIES_IMAGES.DontCatch,
    textKey: 'rules.banned.catch',
  },
  {
    icon: ACTIVITIES_IMAGES.DontWalk,
    textKey: 'rules.banned.restricted',
  },
  {
    icon: ACTIVITIES_IMAGES.Fire,
    textKey: 'rules.banned.fire',
  },
  {
    icon: ACTIVITIES_IMAGES.NoSmoking,
    textKey: 'rules.banned.smoking',
  },
  {
    icon: ACTIVITIES_IMAGES.DontTrash,
    textKey: 'rules.banned.pollute',
  },
  {
    icon: ACTIVITIES_IMAGES.DontDrink,
    textKey: 'rules.banned.picnic',
  },
  {
    icon: ACTIVITIES_IMAGES.Music,
    textKey: 'rules.banned.music',
  },
  {
    icon: ACTIVITIES_IMAGES.WithoutAnimals,
    textKey: 'rules.banned.animals',
  },
  {
    icon: ACTIVITIES_IMAGES.NoBicycle,
    textKey: 'rules.banned.sportItems',
  },
  {
    icon: ACTIVITIES_IMAGES.NoDrones,
    textKey: 'rules.banned.drons',
  },
];

export function Rules() {
  const { t } = useTranslation(COMMON_LOCALE_PART);

  return (
    <>
      <div className="rounded-lg bg-[#92B18B36] p-5">
        <p className="font-medium" dangerouslySetInnerHTML={{ __html: t('rules.hero') ?? '' }} />
      </div>
      <div>
        <h2 className="my-8 text-xl md:text-[32px]">{t('rules.titleAllowed')}</h2>
        <div className="grid grid-cols-1 gap-x-4 gap-y-6 md:grid-cols-2">
          {AllowedActivity.map((activity) => (
            <div className="flex h-36 items-center rounded-lg bg-white px-3 py-4 shadow-lg" key={activity.textKey}>
              <NextImage height={48} width={48} className="h-12 w-12 md:h-[70px] md:w-[70px]" src={activity.icon} alt={activity.textKey} />
              <p
                className="ml-3 text-base font-bold md:text-[16px] [&>span]:font-normal"
                dangerouslySetInnerHTML={{ __html: t(activity.textKey) ?? '' }}
              />
            </div>
          ))}
        </div>
      </div>

      <div>
        <h2 className="my-9 text-xl md:text-[32px]">{t('rules.titleBanned')}</h2>
        <div className="grid grid-cols-1 gap-x-4 gap-y-6 md:grid-cols-2">
          {BannedActivity.map((activity) => (
            <div className="flex h-36 items-center rounded-lg bg-white px-3 py-4 shadow-lg" key={activity.textKey}>
              <NextImage height={48} width={48} className="h-12 w-12" src={activity.icon} alt={activity.textKey} />
              <p
                className="ml-3 text-base font-bold md:text-[16px] [&>span]:font-normal"
                dangerouslySetInnerHTML={{ __html: t(activity.textKey) ?? '' }}
              />
            </div>
          ))}
        </div>
      </div>

      <h2 className="mb-20 mt-9 text-[20px] leading-8 md:text-xl">{t('rules.thanksMessage')}</h2>
    </>
  );
}
